// Func = limiting Scope for this file
var lastScrollTop = 0;
(function () {
	$(document).ready(function () {
		// Main Nav Dropdown
		$('#primary-nav li').hover(
			function () {
				$(this).addClass('hover');
				$('ul.submenu', this).fadeIn(200);
			},
			function () {
				$(this).removeClass('hover');
				$('ul.submenu', this).fadeOut(200);
			}
		);

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date) {
			let d1 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckIn').val());
			let d2 = $.datepicker.parseDate(DATE_FORMAT, $('#CheckOut').val());
			if ((d1 && date.getTime() == d1.getTime()) || (d2 && date.getTime() == d2.getTime())) {
				DATE_STYLE[1] = 'highlight-top';
			} else if (date > d1 && date < d2) {
				DATE_STYLE[1] = 'highlight';
			} else {
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = $('#CheckIn').data('format') !== undefined && $('#CheckIn').data('format') ? $('#CheckIn').data('format') : 'yy-mm-dd';
		$('#CheckIn').datepicker({
			changeMonth: true,
			dateFormat: DATE_FORMAT,
			numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function (selectedDate) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$('#CheckOut').datepicker('setDate', newDate);
				$('#CheckOut').datepicker('option', 'minDate', selectedDate);
			},
		});
		$('#CheckOut').datepicker({
			dateFormat: DATE_FORMAT,
			changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
		});
	});

	// SET ALT-LOGO TO ALT-HEADER
	document.querySelectorAll('.header_alt .js-scroll-logo img').forEach((logoImg) => {
		const logoURL = logoImg.getAttribute('src') || '';
		const logoURL_alt = logoImg.dataset.scroll || logoURL;
		logoImg.setAttribute('src', logoURL_alt);
	});

	window.onload = function () {
		setGalleryMarginTop();
		if(document.querySelectorAll('.topContent').length > 0){
			scrollDownAction(80, 'scroll');
		} else {
			document.querySelector('header').classList.add('scroll');
			let altImage = document.querySelector('.js-scroll-logo').querySelector('img').getAttribute('data-scroll');
			document.querySelector('.js-scroll-logo').querySelector('img').setAttribute('src',altImage)
		}
	};
})();

function setGalleryMarginTop() {
	const headerHeight = document.getElementById('header') ? document.getElementById('header').offsetHeight:0;
	const gallery = document.body.classList.contains('js-is_mobile') ? document.querySelector('#gallery .gallery-mobile') : document.querySelector('#myGallery');
	if (gallery) {
		gallery.style.marginTop = headerHeight + 'px';
	}
}

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function ScrollToSection(IdSection, margin){
	if (document.getElementById(IdSection)){
		let seccion = document.getElementById(IdSection);
		let position = seccion.getBoundingClientRect().top + window.scrollY - margin;
		window.scrollTo({ top: position, behavior: 'smooth' });
	}
	else{
		console.log("Id doesn't exist")
	}
}

function ConvertAnchorToId(anchor){
	let IdSection = anchor.substring(1).toLowerCase();
	if(IdSection == "stay-update"){
		IdSection = "email-signup",
		ScrollToSection(IdSection , 200);
	}
}

document.addEventListener('DOMContentLoaded', function () {
    let fragment = window.location.hash;
    if (fragment) {
		ConvertAnchorToId(fragment);
	}
});